import './Main_Navigation_ChatButton.css';

interface ChatButtonProps {
  onClick: () => void;
  isOpen: boolean;
  // iconImage: string; //COMMENT THIS - MADHURI
}
//update the below function - MADHURI
function ChatButton({ onClick, isOpen }: ChatButtonProps) {
  if (isOpen) return null;
  
  return (
    <button
      onClick={onClick}
      className="chat-button"
      aria-label="Open chat assistant"
    >
      <div className="chat-button-text">
  <span className="ask-text">Ask</span>
  <span className="me-text">
   me
  </span>
</div>
    </button>
  );
}

export default ChatButton;